/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import { AppState } from "../../";

export const taskFilterSelector = (state: AppState) => state.taskfilter;
export const taskFilterRegionIdsSelector = (state: AppState) => state.taskfilter?.regionFilterIds || [];
export const taskFilterTypeSelector = (state: AppState) => state.taskfilter?.selectedTaskType || "";
export const taskFilterStatusSelector = (state: AppState) => state.taskfilter?.selectedTaskStatus || "";
